<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>Assassinations, recriminations, a near-death experience with a suicidal flying examiner, love at first sight, a ghost or two, or three, a famous half-sister, visiting heaven and hell, inventing the hydrofoil and getting caned for it, a naked plumber, a TV wrestler’s trouble in the bedroom, cleaning out a casino and then throwing it all away, helping John Major fight the Kuwait oil fire, dowsing for dead people, patents and planning decisions, lies, truths and uncertainties.</p>
<p>Following a fairly serious motor accident in 2005 which damaged a disc in my neck, I had then, along with the pain of a trapped nerve which kept me awake at night, the luxury of time that I never previously enjoyed to reassess some of the more curious things that have happened to me during my time on this earth. Some of these things are only now beginning to make sense to me. Others perhaps never will. Taken as a whole, all of them lead me inexorably to believe that mankind is far greater than the simple reflection we see of ourselves in the mirror.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2e538fbe